import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCareerList } from "./services/authService";
import SEO from "./components/SEO";

function CareerPage() {
const navigate = useNavigate();
const [jobsData, setJobsData] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchJobs = async () => {
    try {
      const res = await getCareerList({
        search: "",
        page: "1",
        limit: "6",
      });

      if (res.success === "1") {
        setJobsData(res.data.career_job_list);
      }
    } catch (error) {
      console.error("Career API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchJobs();
}, []);


  return (
    <>
       <SEO
        title="Careers at Rolo Transit | Join the Future of Urban Mobility"
        description="Build the next generation of transit tech. Explore job openings, driver partner opportunities, and engineering roles at Rolo Transit Platforms Pvt. Ltd. in Pune."
        keywords="Rolo Transit careers, jobs at Rolo Transit, mobility startup hiring Pune, software engineer jobs Pune, driver partner registration Rolo, startup careers India."
        url="https://rolotransit.com/careers"
      />

   

      {/* page content */}
    <div className="career-page">
      <Navbar />

      {/* HERO */}
      <section className="hero">
        <h1>
          Shape the Future of Mobility: Careers at Rolo Transit
        </h1>
        <p>
          At Rolo, We’re building a safer, smarter way for India to move.
          <br />
          If you are passionate about innovation and impact, we’d love to connect.
        </p>
      </section>

      {/* ABOUT WORKING */}
      <section className="values-section">
        <h2>About working at Rolo.</h2>

        <div className="values-grid">
          <div className="value-card">
            <h3>Mission Driven Work</h3>
            <p>We're building technology that impacts real lives every day.</p>
          </div>

          <div className="value-card">
            <h3>Ownership & Growth</h3>
            <p>We believe in responsibility, initiative, and learning by doing.</p>
          </div>

          <div className="value-card">
            <h3>Safety & Integrity</h3>
            <p>Trust is at the heart of everything we build.</p>
          </div>

          <div className="value-card">
            <h3>Fast Growing Environment</h3>
            <p>Be part of a company shaping the future of urban mobility.</p>
          </div>
        </div>
      </section>

      {/* JOBS SECTION */}
<section className="jobs-section">
  <h2>We are exploring</h2>

  <div className="jobs-grid">
    {loading ? (
      <p className="jobs-message">Loading jobs...</p>
    ) : jobsData.length === 0 ? (
      <div className="jobs-empty">
        <p>
          Looks quiet here 👀 <br />
          We’re not hiring right now, but something exciting could pop up anytime.
          <br />
          Stay tuned!
        </p>
      </div>
    ) : (
      jobsData.map((job) => (
        <div
          key={job.job_id}
          className="job-card"
          onClick={() =>
            navigate(`/job/${job.job_id}`, { state: job })
          }
          style={{ cursor: "pointer" }}
        >
          <div
            className="job-img"
            style={{
              backgroundImage: `url(${job.job_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          <h4>{job.job_title}</h4>

          <p>
            {job.job_description
              ?.replace(/(\r\n|\n|\r)/gm, " ")
              .substring(0, 100)}
            ...
          </p>

          <small style={{ color: "#888" }}>
            {job.job_location} • {job.employment_type}
          </small>
        </div>
      ))
    )}
  </div>
</section>
 

      <Footer />

      {/* STYLES */}
      <style>{`
        .career-page {
          background: #000;
          color: white;
          font-family: 'Inter', sans-serif;
        }

        /* HERO */
        .hero {
          text-align: center;
          padding: 120px 10% 60px;
        }

        .hero h1 {
          font-size: 64px;
          font-weight: 800;
          color: #FF8C32;
          line-height: 1.2;
          margin-bottom: 20px;
        }

        .hero p {
          font-size: 18px;
          color: #ccc;
          font-weight: 500;
        }

        /* HEADINGS */
        h2 {
          color: #FF8C32;
          font-size: 28px;
          margin-bottom: 40px;
        }

        /* VALUES */
        .values-section {
          padding: 50px 10%;
        }

        .values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 30px;
        }

        .value-card {
          height: 240px;
          width: 240px;
          background: #F3CDB1;
          color: black;
          padding: 25px;
          border-radius: 15px;
        }

        .value-card h3 {
          font-family: Inter;
font-weight: 800;
font-style: Extra Bold;
font-size: 30px;
leading-trim: NONE;
line-height: 104%;
letter-spacing: 0%;
color: #D25A00;

        }

        .value-card p {
          font-family: Inter;
font-weight: 500;
font-style: Medium;
font-size: 18px;
leading-trim: NONE;
line-height: 115.99999999999999%;
letter-spacing: 0%;
color: #000000;
        }

        /* JOBS */
        /* JOBS */
.jobs-section {
  padding: 60px 10% 120px;
}

.jobs-section h2 {
  margin-bottom: 50px;
}

/* GRID */
.jobs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 120px; /* more balanced spacing like design */
  align-items: start;
}

/* CARD */
.job-card {
  display: flex;
  flex-direction: column;
  align-items: center; /* center EVERYTHING */
  text-align: center;
}

/* IMAGE BOX */
.job-img {
  width: 220px;
  height: 220px;
  background: #cfcfcf;
  border-radius: 20px;
  margin-bottom: 20px;
}

/* TITLE */
.job-card h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* DESCRIPTION */
.job-card p {
  font-size: 12px;
  color: #aaa;
  max-width: 260px; /* IMPORTANT for alignment */
  line-height: 1.4;
}
  .job-card:hover {
  transform: translateY(-5px);
  transition: 0.3s;
}
/* JOIN SECTION */
.join-section {
  background: #000;
  padding: 100px 10%;
}

/* CONTAINER */
.join-container {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 100px;
 
}

/* LEFT SIDE */
.join-left h2 {
  font-size: 56px;
  font-weight: 800;
  color: #FF7F1F;
  line-height: 1.1;
  margin-bottom: 20px;
}

.join-left p {
  font-size: 18px;
  color: #dcdcdc;
  line-height: 1.6;
  max-width: 420px;
}

/* FORM */
.join-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* INPUTS */
.join-form input,
.join-form textarea {
  background: #2b2b2b;
  border: none;
  border-radius: 10px;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  outline: none;
}

/* PLACEHOLDER */
.join-form input::placeholder,
.join-form textarea::placeholder {
  color: #FC9344;
}



/* TEXTAREA */
.join-form textarea {
  height: 120px;
  resize: none;
}
  .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
}

/* UPLOAD BOX */
.upload-box {
  background: #E6C3A5;
  color: #000;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

/* ICON */
.upload-icon {
  font-size: 18px;
  color: #FF7F1F;
}

/* NOTE TEXT */
.note {
  font-size: 12px;
  color: #aaa;
}

.note span {
  color: #00BFFF;
  cursor: pointer;
}

/* POLICY */
.policy {
  font-size: 11px;
  color: #777;
  line-height: 1.5;
}

/* BUTTON */
.join-form button {
  background: linear-gradient(90deg, #FF7F1F, #FF5A00);
  border: none;
  padding: 16px;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;
}

.join-form button:hover {
  opacity: 0.9;
}
  .jobs-empty {
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  grid-column: 1 / -1; /* 🔥 spans full grid */
}

.jobs-empty p {
  font-size: 20px;
  color: #ffffff;
 
  max-width: 500px;
}

.jobs-message {
  text-align: center;
  width: 100%;
  grid-column: 1 / -1;
}



        /* RESPONSIVE */
        @media (max-width: 900px) {
          .hero h1 {
            font-size: 40px;
          }

          .jobs-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
        }
      `}</style>
    </div>
    </>
  );
}

export default CareerPage;